import { useSubGoals } from 'features/goals';
import { useHabits, useRepeatingTasks } from 'features/tasks';
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Section, Sizes } from 'shared/components/ui/section';
import { TasksList } from 'shared/components/ui/tasks-list';
import { Goal } from 'shared/types/goal';
import { Task } from 'shared/types/task';

export type ArchivedItemsListProps = {
  goal: Goal;
};

export const ArchivedItemsList: React.FC<ArchivedItemsListProps> = ({
  goal,
}) => {
  const { t } = useTranslation();

  const subGoals = useSubGoals(goal.id, true);
  const goalIds = useMemo(
    () => [goal.id, ...subGoals.map((g) => g.id)],
    [goal.id, subGoals],
  );

  const habits = useHabits({
    goals: goalIds,
    archivedOnly: true,
  });

  const repeatingTasks = useRepeatingTasks({
    goals: goalIds,
    archivedOnly: true,
  });

  const archivedItems = useMemo(() => {
    const items = [...habits, ...repeatingTasks];
    return items.sort(
      (a, b) => (a.archivedAt?.getTime() ?? 0) - (b.archivedAt?.getTime() ?? 0),
    ) as Task[];
  }, [habits, repeatingTasks]);

  if (!archivedItems.length) {
    return null;
  }

  return (
    <Section
      title={t('pages.goal-detail.tasks.archived.title', 'Archived')}
      titleCount={archivedItems.length}
      size={Sizes.Small}
      canCollapse
    >
      <TasksList tasks={archivedItems} hideGoal />
    </Section>
  );
};
